import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import Mainbg from './imgs/main-bg@2x.png';
import styled from 'styled-components';
import Tabs from './components/tabs';
import cardBg1 from './imgs/card-bg1@2x.png';
import cardBg1Light from './imgs/card-bg1-light@2x.png';
import cardBg2 from './imgs/card-bg2@2x.png';
import cardBg2Ligth from './imgs/card-bg2-light@2x.png';
import StarLeft from "./imgs/star-left@2x.png";
import StarRight from "./imgs/star-right@2x.png";
import Award1 from './imgs/award1@2x.png';
// import Award2 from './imgs/award2@2x.png';
import InviteCard from './imgs/invite-card.png';
import AwardIcon from './imgs/award-icon@2x.png';
import ChimpionImg from './imgs/champion@2x.png';
import StarImg from './imgs/star@2x.png';
import SplitLine from './imgs/split-line@2x.png';
import RankEmpty from './imgs/rank-empty@2x.png';
import HeadRrrow from './imgs/head-arrow@2x.png';
import RankTable from './components/rank-table';
import { jumpTo } from '@/utils';
import { getMyAward, getActiveData, getMonthRank, sendShare } from './api';
import moment from 'moment';
import ShareBottom from './imgs/share-bottom@2x.png';
import ShareModal from './components/share'
import CommonModal from './components/common-modal';
import bridge, { isiOS } from '@/config/JSbridge';
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
import styles from '@/styles';
import WithdrawList from './components/withdraw-list';
import ArriveModal from './components/arrive-modal';
import { connect } from 'react-redux';
import { Toast } from 'antd-mobile';
import StormLogo from './imgs/storm.png'

const tabs = ['邀请好友', '我的奖励', '邀请榜单', '规则说明']

const InviteActivity = ({ accessToken }) => {
  const [contentIndex, setContentIndex] = useState(1);
  const [rankIndex, setRankIndex] = useState(1);
  const [bonusData, setMyBonusData] = useState({});
  const [activeData, setActiveData] = useState({});

  const [monthRank, setMonthRank] = useState({});
  const [preMonthRank, setPreMonthRank] = useState({});

  const [activityClosed, setActivityClosed] = useState(false);

  const shareRef = useRef();
  const commonModalref = useRef();
  const arriveModalRef = useRef();

  const navTop1 = useRef();
  const navTop2 = useRef();
  const navTop3 = useRef();
  const navTop4 = useRef();
  const tabRef = useRef();

  const isLinkToShareRef = useRef(false);
  const activeDataRef = useRef(null);
  activeDataRef.current = activeData;

  const handleLinkToDetail = () => {
    if (!accessToken) {
      handleLogin();
      return;
    }
    isLinkToShareRef.current = false;
    jumpTo('/active_42/my');
  }

  useEffect(() => {
    fetchMyAward();
    fetchActiveData();

    fetchMonthRank().then(res => setMonthRank(res));
    fetchMonthRank(true).then(res => setPreMonthRank(res));

    bridge.addRegisterHandler([{
      name: 'viewWillAppear',
      callback: () => {
        if (isLinkToShareRef.current && activeDataRef.current.activityState === 2) {
          Toast.info('邀请好友活动正在维护中，邀请成功将不再发放任何奖励');
        };
  
        fetchMyAward();
        fetchMonthRank().then(res => setMonthRank(res));
        fetchMonthRank(true).then(res => setPreMonthRank(res));
      }
    }]);
  }, []);

  useLayoutEffect(() => {
    const scrollElement = document.scrollingElement;
    document.addEventListener('scroll', () => {
      const scrollTop = scrollElement.scrollTop;
      let index = 0;
      if (scrollTop + 38 >= navTop2.current.offsetTop) {
        index = 1;
      }
      if (scrollTop + 38 >= navTop3.current.offsetTop) {
        index = 2;
      }
      if (scrollTop + 38 >= navTop4.current.offsetTop) {
        index = 3;
      }
      tabRef.current.setIndex(index);
    });
  }, []);

  const handleSelectTab = (index) => {
    let selectRef = null;
    switch(index) {
      case 0: selectRef = navTop1;break;
      case 1: selectRef = navTop2;break;
      case 2: selectRef = navTop3;break;
      case 3: selectRef = navTop4;break;
      default: selectRef = navTop1; break;
    }
    document.scrollingElement.scrollTop = selectRef.current.offsetTop - 38;
  }

  const fetchMyAward = () => {
    getMyAward({ activityId: 60 }).then(res => {
      setMyBonusData(res);
      commonModalref.current.updateModal(res);

      if (res.newArriveBonus) {
        arriveModalRef.current.show(res);
      }
    })
  }

  const fetchActiveData = () => {
    getActiveData({activityId: 60}).then(res => {
      if (res.activityState === 2) {
        setActivityClosed(true);
      }
      setActiveData(res);
    })
  }

  const fetchMonthRank = (preMonth) => {
    return new Promise((resolve, reject) => {
      const now = moment();
      let dateStr = now.format('YYYY-MM');
      if (preMonth) {
        dateStr = now.subtract(1, 'month').format('YYYY-MM')
      }
      getMonthRank({ "month": dateStr }).then(res => {
        resolve(res);
      }).catch(err => reject(err))
    })
    
  }

  const handleShareClick = () => {
    isLinkToShareRef.current = true;
    sendShare();
  }

  const handleLinkToValid = () => {
    isLinkToShareRef.current = false;
    window.location.href = 'storm://app/authentication/realname'
  }

  const handleBindAlipay = () => {
    if (!bwmodel.compareVersion('5.22.0')) {
      Toast.info("当前版本无法绑定，请升级至最新版本")
      return;
    }
    isLinkToShareRef.current = false;
    bridge.callHandler('nativeEvent', {
      event: isiOS ? 'bindZFB' : 'bindAliPay',
      params: {
        url: bonusData.alipayJumpUrl,
        params: bonusData.androidAlipayJumpUrl
      }
    }, res => {
      const response = JSON.parse(res);
      if (response.code === 0) {
        if (response.params.result === true) {
          const nextBonusData = { ...bonusData };
          nextBonusData.alipayBound = 1
          setMyBonusData(nextBonusData);

          commonModalref.current.close();

          Toast.info("绑定成功");
        } else {
          Toast.info("绑定失败");
        }
      }
    })
  }

  const handleWithdraw = () => {
    const withdrawableBonus = bonusData.withdrawableBonus || 0;

    if (withdrawableBonus < 10) {
      commonModalref.current.show(
        <CommonModalWrap>
          <div className='withdraw-tips'>
            <div>
              可提奖励需大于<span className='withdraw-scope'>10元</span>才可进行提现
            </div>
            <div>可通过邀请好友获得奖励金额</div>
          </div>
          <div className='confirm-btn-wrap'>
            <div className='confirm-btn' onClick={() => commonModalref.current.close()}>知道了</div>
          </div>
        </CommonModalWrap>
      )
      return
    }
    if (bonusData.authRealPerson === 0) {
      commonModalref.current.show(
        <CommonModalWrap>
          <div className='withdraw-tips'>
            <div>首次提现账号需完成「实名认证」</div>
            <div>请先进行实名认证</div>
          </div>
          <div className='options-btn-wrap'>
            <div className='cancel-btn' onClick={() => commonModalref.current.close()}>取消</div>
            <div className='confirm-btn' onClick={handleLinkToValid}>去认证</div>
          </div>
        </CommonModalWrap>,
        'authRealPerson'
      )
      return;
    }

    if (bonusData.alipayBound === 1) {
      isLinkToShareRef.current = false;
      jumpTo('/active_42/withdraw');
    } else {
      commonModalref.current.show(
        <CommonModalWrap>
          <div className='withdraw-tips'>
            首次提现需绑定账号
          </div>
          <div className='options-btn-wrap'>
            <div className='cancel-btn' onClick={() => commonModalref.current.close()}>取消</div>
            <div className='confirm-btn' onClick={handleBindAlipay}>去绑定</div>
          </div>
        </CommonModalWrap>,
        'alipayBound'
      )
    }
  }

  const handleLogin = () => {
    isLinkToShareRef.current = false;
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

  const handleShowShare = () => {
    if (!accessToken) {
      handleLogin();
      return;
    }
    if (shareRef.current) {
      shareRef.current.show()
    }
  }

  const handleAwardDetail = () => {
    commonModalref.current.show(
      <CommonModalWrap>
        <div className='invite-tips'>
          <div className='tips-item'>
            <span className='award-type'>待提奖励：</span>
            <span>邀请好友或榜单获得的奖励，支持提现</span>
          </div>
          <div className='tips-item'>
            <span className='award-type'>已提奖励：</span>
            <span>已提现和提现审核的奖励</span>
          </div>
          <div className='tips-item'>
            <span className='award-type'>过期奖励：</span>
            <span>获得的奖励，在30天内未进行提现会做过期处理，无法再进行提现</span>
          </div>
        </div>
        <div className='confirm-btn-wrap'>
          <div className='confirm-btn' onClick={() => commonModalref.current.close()}>知道了</div>
        </div>
      </CommonModalWrap>
    )
  }

  const withdrawableBonus = bonusData.withdrawableBonus || 0;
  const withdrawnBonus = bonusData.withdrawnBonus || 0;
  const expiredBonus = bonusData.expiredBonus || 0;
  const invitedCount = bonusData.invitedCount || 0;

  const rankData = rankIndex === 1 ? monthRank : preMonthRank;

  const rankDataFormat = (() => {
    return rankData.rankingList
  })()

  const {
    avatar,
    bonus,
    sendInviteUrlCount,
    inviteCount,
    isInRanking = '',
    ranking = '',
    rankingBonus = '',
    disparityMoney = '',
    disparityPeopleCount = ''
  } = rankData.myRankingInfo || {}
  
  return (
    <Container>
      <Header
        title="邀请好友"
        right={<img onClick={handleShowShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
        hideNaviBar
        bg_color={styles.bg_color2}
        className="page-header"
      />
      <div className='page-content'>
        <div className='tabs-wrap'>
          <div className='tabs-container'>
            <Tabs ref={tabRef} tabs={tabs} onClick={handleSelectTab} />
          </div>
        </div>
        <div className="activity-status-container">
          <div className='activity-text'>{activeData.activityState === 1 ? '限时开启' : '已结束'}</div>
          <img alt='' src={HeadRrrow} className='activity-status-img'/>
        </div>
        <div className="scroll-withdraw-box">
          <WithdrawList />
        </div>
        <div className='active-container' ref={navTop1}>
          {activityClosed && <div className='finish-mask'>
            活动维护中
          </div>}
          <div className='content-tabs'>
            <div onClick={() => setContentIndex(1)} className={`content-tab content-tab1 ${contentIndex === 1 ? '' : 'content-tab-select'}`}>邀请新好友</div>
            <div onClick={() => setContentIndex(2)} className={`content-tab content-tab2 ${contentIndex === 2 ? '' : 'content-tab-select'}`}>召回老朋友</div>
          </div>
          <div className='active-content'>
            <div className='active-title'>
              <div className='star-wrap'>
                <img className='star-img' src={StarLeft} alt=''/>
              </div>
              <div className='active-title-text'>{contentIndex === 1 ? '每邀请1位新好友' : '每召回1位老朋友'}</div>
              <div className='star-wrap'>
                <img className='star-img' src={StarRight} alt=''/>
              </div>
            </div>
            <div className='award-wrap'>
              <div className='award-item'>
                <div className='award-box1'>
                  <div className='award1-wrap'>
                    <img className='award1' alt='' src={Award1} />
                  </div>
                  <div className='award-label-title'>你最高可得</div>
                  <div className='award-label-value'>{contentIndex === 1 ? '300' : '300'} 元</div>
                </div>
              </div>
              {/* <div className='split-line'></div>
              <div className='award-item'>
                <div className='award-box2'>
                  <div className='award2-wrap'>
                    <img className='award2' alt='' src={Award2} />
                  </div>
                  <div className='award-label-title'>好友{contentIndex === 1 ? '最高' : ''}可得</div>
                  <div className='award-label-value'>{contentIndex === 1 ? '8' : '1'}天风云VIP</div>
                </div>
              </div> */}
            </div>
            <div className={`invite-btn-wrap`}>
              <div onClick={handleShowShare} className='invite-must'>立即邀请赚钱</div>
            </div>
            <div className='invite-desc'>市值风云APP：“你来安利我，我来给你钱！”</div>
          </div>
        </div>
        {contentIndex === 1 &&
          <div className='award-list-container'>
            <div className='award-list-box'>
              <div className='award-list'>
                <div className='award-content'>
                  <div className='award-label'>奖励1</div>
                  <div className='award-text'>好友在市值风云指定证券开户入金</div>
                </div>
                <div className='award-bonus'>得100元</div>
              </div>
              <div className='award-list fix-bottom'>
                <div className='award-content'>
                  <div className='award-label'>奖励2</div>
                  <div className='award-text'>好友购买风云VIP年卡</div>
                </div>
                <div className='award-bonus'>得200元</div>
              </div>

              <div className='customArraw'></div>
            </div>
          </div>
        }
        {contentIndex === 2 &&
          <div className='award-list-container'>
            <div className='award-list-box'>
              <div className='award-list'>
                <div className='award-content'>
                  <div className='award-label'>奖励1</div>
                  <div className='award-text'>好友在市值风云指定证券开户入金</div>
                </div>
                <div className='award-bonus'>得100元</div>
              </div>
              <div className='award-list fix-bottom'>
                <div className='award-content'>
                  <div className='award-label'>奖励2</div>
                  <div className='award-text'>好友购买风云VIP年卡</div>
                </div>
                <div className='award-bonus'>得200元</div>
              </div>
              <div className='customArraw customArraw2'></div>
            </div>
          </div>
        }
        <div className='invite-wrap' ref={navTop2}>
          <div className='invite-card-bg' onClick={handleAwardDetail}>
            <div className='invite-text'>我的奖励</div>
            <img className='invite-icon' src={AwardIcon} alt='' />
          </div>
          <div className='invite-card'>
            <div className='invite-data-wrap'>
              <div className='invite-nums'>
                <div className='invite-item'>待提奖励</div>
                <div className='invite-value'>{withdrawableBonus}元</div>
              </div>
              <div className='invite-split'></div>
              <div className='invite-nums'>
                <div className='invite-item'>已提奖励</div>
                <div className='invite-value'>{withdrawnBonus}元</div>
              </div>
              <div className='invite-split'></div>
              <div className='invite-nums'>
                <div className='invite-item'>过期奖励</div>
                <div className='invite-value'>{expiredBonus}元</div>
              </div>
              <div className='invite-split'></div>
              <div className='invite-nums'>
                <div className='invite-item'>邀请人数</div>
                <div className='invite-value'>{invitedCount}人</div>
              </div>
            </div>
            <div className='withdraw-wrap'>
              <div className='withdraw-btn' onClick={handleWithdraw}>
                <div className='withdraw-text'>申请提现</div>
                <div className='withdraw-desc'>10元以上可提</div>
              </div>
            </div>
          </div>
        </div>
        <div className='rank-container' ref={navTop3}>
          <div className='content-tabs'>
            <div onClick={() => setRankIndex(1)} className={`content-tab content-tab1 ${rankIndex === 1 ? '' : 'content-tab-select'}`}>本月邀请榜单</div>
            <div onClick={() => setRankIndex(2)} className={`content-tab content-tab2 ${rankIndex === 2 ? '' : 'content-tab-select'}`}>上月邀请榜单</div>
          </div>
          {rankData.isRankingOpen ? (
            <div className='rank-content'>
              <div className='rank-box'>
                <div className='champion-user'>
                  <div className='champion1 champion-item'>
                    {Array.isArray(rankData.rankingList) && rankData.rankingList[1] ? (
                      <div className='champion-item'>
                        <div className='user-bg'>
                          <img className='champion-avatar' alt='' src={rankDataFormat[1].avatar}/>
                        </div>
                        <div className='champion-name'>{rankDataFormat[1].nickname}</div>
                        <div className='champion-award'>奖励{rankDataFormat[1].bonus}元</div>
                      </div>
                    ) : (
                      <div className='champion-empty'>暂无</div>
                    )}
                  </div>
                  <div className='champion2 champion-item'>
                    {Array.isArray(rankData.rankingList) && rankData.rankingList[0] ? (
                      <div className='champion-item'>
                        <div className='user-bg'>
                          <img className='champion-avatar' alt='' src={rankDataFormat[0].avatar}/>
                        </div>
                        <div className='champion-name'>{rankDataFormat[0].nickname}</div>
                        <div className='champion-award'>奖励{rankDataFormat[0].bonus}元</div>
                      </div>
                    ) : (
                      <div className='champion-empty'>暂无</div>
                    )}
                  </div>
                  <div className='champion3 champion-item'>
                    {Array.isArray(rankData.rankingList) && rankData.rankingList[2] ? (
                      <div className='champion-item'>
                        <div className='user-bg'>
                        <img className='champion-avatar' alt='' src={rankDataFormat[2].avatar}/>
                        </div>
                        <div className='champion-name'>{rankDataFormat[2].nickname}</div>
                        <div className='champion-award'>奖励{rankDataFormat[2].bonus}元</div>
                      </div>
                    ) : (
                      <div className='champion-empty'>暂无</div>
                    )}
                  </div>
                </div>
                <div className='champion-wrap'>
                  <img className='champion-img' src={ChimpionImg} alt=''/>
                </div>
              </div>
              <div className='champion-desc'>邀请榜单前3用户会额外获得奖励，奖励会在本期结算后发到账户</div>
              <div className='rank-split'>
                <div className='split-dot split-dot1'></div>
                <div className='split-line'></div>
                <div className='split-star'></div>
                <div className='split-text'>邀请明细</div>
                <div className='split-star'></div>
                <div className='split-line'></div>
                <div className='split-dot split-dot2'></div>
              </div>
              <RankTable data={rankData.rankingList || []} />
              <div className='rank-self'>
                <div className='self-wrap'>
                  <div className='self-avatar'><img className='my-avatar' alt='' src={avatar}/></div>
                </div>
                <div className='rank-value-wrap'>
                  <div className='self-values'>
                    <span className='self-text'>我</span>
                    <span>{sendInviteUrlCount || 0}次</span>
                    <span>{inviteCount || 0}人</span>
                    <span>{bonus || 0}元</span>
                  </div>
                  {rankIndex === 1 && <div className='rank-distance'>
                    {isInRanking ? `本月排名第${ranking}名，本月结束后预计可获得${rankingBonus}额外奖励`
                    : `距离上榜还差${disparityMoney}元，预计还要邀请${disparityPeopleCount}人`}
                  </div>}
                </div>
              </div>
            </div>
          ) : (
            <div className='rank-content'>
              <div className='rank-empty'>
                <img alt='' src={RankEmpty} className='rank-empty-img' />
                <div className='rank-empty-title'>榜单未开启</div>
                <div className='rank-empty-desc'>暂未满足开启条件，快去邀请好友合力开启榜单</div>
                <div className='rank-empty-desc'>榜单开启后，上榜用户会有现金奖励</div>
              </div>
            </div>
          )}
          
        </div>
        <div className='invite-wrap rule-container' ref={navTop4}>
          <div className='invite-card-bg'>
            <div className='invite-text'>活动相关说明</div>
          </div>
          <div className='rule-wrap'>
            <div className='rule-title'>【活动介绍】</div>
            <div className='heavy-title'>一、活动时间：本活动为限时活动，活动时间、参与范围、奖励机制等会适时根据活动情况进行一定调整，具体以本活动页面和风云官方@风云话题 发布的通知内容为准。</div>
            <div className='heavy-title'>二、活动奖励共分2种：邀请奖励和上榜奖励，2种奖励可叠加。上述2种奖励均为红包奖励，该奖励的有效期为30天，即获得后需在30天内完成提现，30天内未完成提现的金额将被自动清零，因此建议获得奖励金额后尽快提现。</div>
            <div className='heavy-title'>三、奖励提现：获得的奖励金额支持提现，提现时需要满足3个条件：</div>
            <div>1）提现时账号需完成实名认证；</div>
            <div>2）提现时账号需绑定账号；</div>
            <div>3）提现金额需在10元及以上；上述3个条件同时满足才能提现，缺一不可。</div>
            <div className='rule-title'>【邀请规则】</div>
            <div>一、将本活动页分享给好友，好友通过你的分享链接绑定、注册、下载并登录市值风云APP，你即可获得相应奖励：</div>
            <div className='heavy-title'>若好友是新用户，则：</div>
            <div>1）好友在注册的15天内，在市值风云App指定券商开户，并且开户成功后日均资产连续40个交易日1万元，你得100元奖励金额；（具体领取开户奖励步骤详见下文【四、领取好友证券开户入金奖励步骤】）</div>
            <div>2）好友在注册的15天内，购买成功风云VIP年卡，你得200元奖励金额；</div>
            <div className='heavy-title'>注：本活动新用户是指未曾使用、注册、登录过市值风云APP的用户；且首次打开APP距离在“邀请链接”绑定的时间不超过72小时。</div>
            <div className='heavy-title'>2、若好友是老用户，则：</div>
            <div>1）好友在召回的15天内，在市值风云App指定券商开户，并且开户成功后日均资产连续40个交易日1万元，你得100元奖励金额；（具体领取开户奖励步骤详见下文【四、领取好友证券开户入金奖励步骤】）</div>
            <div>2）好友在召回的15天内，购买成功风云VIP年卡，你得200元奖励金额；</div>
            <div className='heavy-title'>注：本活动的老用户为回归用户，是指参与活动前账号和使用的设备在近30天未使用过市值风云APP的用户；且回归后首次打开APP距离在“邀请链接”绑定的时间不超过72小时；</div>
            <div className='heavy-title'>二、邀请好友数量无上限，邀请越多奖励金额越多哦；</div>
            <div>三、邀请的好友完成进度可在本活动页的“我的邀请”查看，好友完成对应条件后奖励会自动发放到你的账中；</div>
            <div>四、领取好友证券开户入金奖励步骤：</div>
            <div>1）好友开户并入金：在市值风云APP-&gt;交易-&gt;A股-&gt;银河证券/首创证券/广发证券/方正证券-&gt;开户，开户成功后同时在市值风云APP所开的证券账户中入金日均资产连续40个交易日1万元及以上；</div>
            <div>2）邀请人提交材料审核并领奖：邀请人获得好友的开户入金证明材料（市值风云手机号、开户手机号、开户入金截图等），联系@风云话题 或者风云官方客服企业微信（见下图二维码），并提交上述相关开户入金证明进行审核，审核通过后人工发放开户奖励。</div>

            <div className='storm-img-wrap'>
              <img alt='' src={StormLogo} className='storm-img'/>
            </div>

            <div className='rule-title'>【注意事项与平台规则】</div>
            <div>一、本活动为限时活动，活动存在多方面因素会导致本活动关闭，活动关闭后邀请奖励将不再发放（对已发放的奖励不受影响），活动关闭后奖励提现可正常操作。</div>
            <div>二、市值风云依法运营本活动，并有权根据法律法规、国家政策、行业规范、市值风云经营策略和或合作方（如有）的变化调整，单方变更、中止、终止本活动，市值风云无须为此承担任何责任。</div>
            <div>三、因不可抗力（指不能预见、不能避免且不能克服的客观情况，包括国家法律、法规、政策及国家机关的命令及其他政府行为或者其它的诸如台风、洪水、地震、海啸、战争、罢工等）及不可归责于市值风云的原因，导致您无法参与本活动或参与失败的，市值风云无须为此承担任何责任。</div>
            <div>四、活动期间，因您自身原因（包括但不限于操作不当、错过活动时间等）导致无法参与本活动或参与失败的，市值风云无须为此承担任何责任。</div>
            
            <div className='rule-title'>【参与资格、获奖资格的取消】</div>
            <div>一、您不得以不正当手段或舞弊行为参与本活动，包括但不限于：开设多个市值风云账号重复参与本活动，或通过机器人软件、蜘蛛软件、插件、群控软件、软件外挂、物理外挂、模拟器等任何程序或技术手段（包括但不限于刷粉、盗用他人账号、提供虚假信息等）参与本活动。</div>
            <div>二、您不得在活动期间违反法律法规、市值风云平台规则和/或本活动规则，或在本活动前曾因违反市值风云平台规则导致账号封禁。</div>
            <div>三、如我们发现或接举报后发现您存在以上任意一种情况，一经查实，我们有权采取包括但不限于取消您的参与资格、取消奖励、追回已发放奖励等措施。</div>
            <div>四、请您通过市值风云官方手机APP客户端参与本活动。市值风云无须对非经市值风云指定途径参与本活动的用户，或非经市值风云官方名义发布的信息承担任何义务或责任。</div>
            <div>特别声明：本活动与Apple Inc.无关。</div>
          </div>
        </div>
        <div className='active-desc'>本活动一切解释权归市值风云官方所有</div>
        <div onClick={handleLinkToDetail} className='my-invite-btn'>
          <div>我的</div>
          <div>邀请</div>
        </div>
        <div className='bottom-fixed' onClick={handleShowShare}>
          <div className='share-arraw-wrap'>
            <img src={ShareBottom} alt='' className='share-arraw'/>
          </div>
          <div className='bottom-share'>听说分享到微信群/QQ群，邀请成功率会提高188%哦！</div>
        </div>
        <ShareModal
          activeData={activeData}
          ref={shareRef}
          onShareClick={handleShareClick}
          isLogin={!!accessToken}
        />
        <CommonModal ref={commonModalref} />
        <ArriveModal ref={arriveModalRef}/>
      </div>
    </Container>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.user.accessToken
});

export default connect(mapStateToProps)(InviteActivity);

const CommonModalWrap = styled.div`
  .confirm-btn-wrap {
    display: flex;
    justify-content: center;
  }
  .confirm-btn {
    width: 156px;
    height: 37px;
    background: linear-gradient(-90deg, #FB4C3D 0%, #FDBE37 99%);
    border-radius: 19px;
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .options-btn-wrap {
    display: flex;
    align-items: center;
    justify-content: space-around;
    .confirm-btn {
      width: 135px;
    }
  }
  .cancel-btn {
    width: 135px;
    height: 37px;
    border: 2px solid #FDBE37;;
    border-radius: 19px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: 400;
    color: #FB513D;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .invite-tips {
    padding: 14px 22px 0 18px;
    .tips-item {
      margin-bottom: 10px;
      font-size: 15px;
      line-height: 20px;
    }
    .award-type {
      font-weight: bold;
    }
  }

  .withdraw-tips {
    padding: 14px 19px 23px;
    font-size: 18px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    text-align: center;
    color: #000000;
    line-height: 27px;
    .withdraw-scope {
      color: #FF7022;
      font-size:26px;
      font-weight: Bold;
      line-height: 27px;
    }
  }
`;

const Container = styled.div`
  .storm-img-wrap {
    display: flex;
    justify-content: center;
    margin-top: 12px;
    .storm-img {
      width: 120px;
      height: 120px;
    }
  }
  .page-header {
    height: 44px;
  }
  .activity-status-container {
    position: absolute;
    top: 0;
    left: 0;
    padding: 20px 0 0 15px;
    display: flex;
    align-items: center;
    .activity-text {
      width: 67px;
      height: 20px;
      border: 1px solid #b62e1a;
      border-radius: 10px;
      font-size: 11px;
      font-weight: 500;
      color: #b62e1a;
      line-height: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .activity-status-img {
      width: 95px;
      height: 20px;
      margin-left: 4px;
    }
  }
  .scroll-withdraw-box {
    height: 70px;
    width: 100%;
    z-index: 1;
    position: absolute;
    right: 0;
    top: 123px;
  }
  .page-content {
    background-image: url(${Mainbg});
    background-size: 100%;
    background-repeat: no-repeat;
    background-color: #C23A2E;
    position: relative;
    padding-top: 203px;
  }
  .tabs-wrap {
    padding: 0 15px;
    position: sticky;
    top: 44px;
    z-index: 100;
    .tabs-container {
      border-radius: 8px;
      height: 38px;
      background: linear-gradient(270deg, rgba(255, 215, 207, 0.8) 0%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 236, 227, 0.8) 100%);
    }
  }
  .active-container {
    position: relative;
    padding: 0 15px;
    margin-top: 14px;
    .finish-mask {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.75);
      z-index: 4;
      font-size: 30px;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
  .active-content {
    background: linear-gradient(0deg, #FFE7E1 0%, #FFFFFF 100%);
    border-radius: 0 0 8px 8px;
  }
  .content-tabs {
    height: 39px;
    display: flex;
    position: relative;
    .content-tab {
      height: 39px;
      width: 52%;
      top: 0;
      position: absolute;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      font-size: 17px;
      font-weight: 500;
      color: #323232;
    }
    .content-tab1 {
      left: 0;
      background-image: url(${cardBg1});
      z-index: 3;
    }
    .content-tab2 {
      right: 0;
      background-image: url(${cardBg2});
      z-index: 2;
    }
    .content-tab1.content-tab-select {
      background-image: url(${cardBg1Light});
      z-index: 2;
      color: #fff;
    }
    .content-tab2.content-tab-select {
      background-image: url(${cardBg2Ligth});
      z-index: 2;
      color: #fff;
    }
  }
  .active-title {
    display: flex;
    justify-content: center;
    padding-top: 16px;
    .star-wrap {
      height: 20px;
      display: flex;
      align-items: flex-end;
    }
    .star-img {
      width: 23px;
      height: 13px;
    }
    .active-title-text {
      font-size: 20px;
      line-height: 20px;
      margin: 0 7px;
      font-family: Alibaba PuHuiTi;
      font-weight: 800;
      background: linear-gradient(-83deg, #FF415F 0%, #FFA95B 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .award-wrap {
    display: flex;
    padding: 0 20px;
    .award-item {
      flex: 1;
      display: flex;
      justify-content: center;
      .award-label-title {
        font-size: 17px;
        font-weight: 400;
        color: #1C1C1C;
        line-height: 24px;
      }
      .award-label-value {
        font-size: 22px;
        font-weight: 400;
        color: #FB4A42;
        line-height: 24px;
        font-weight: 800;
      }
      .award-box1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        .award-label-title {
          margin-top: 8px;
        }
      }
      .award-box2 {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .award1-wrap {
        padding-top: 12px;
        padding-left: 20px;
        .award1 {
          width: 104px;
          height: 77px;
        }
      }
      .award2-wrap {
        padding-top: 4px;
        .award2 {
          width: 110px;
          height: 92px;
        }
      }
    }
    .split-line {
      margin-top: 34px;
      width: 1px;
      height: 130px;
      background-color: #969696;
    }
  }
  .award-list, .award-content {
    display: flex;
  }
  .award-list {
    margin-bottom: 17px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .fix-bottom {
    margin-bottom: 0;
  }
  .award-content {
    flex: 1;
  }
  .award-label {
    margin-right: 14px;
    width: 47px;
    height: 17px;
    border-radius: 8px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(270deg, #FB4541 0%, #FF954E 99%);
    font-weight: 500;
    color: #FFFFFF;
  }
  .award-text {
    font-size: 13px;
    font-weight: 400;
    color: #1A1A1A;
    line-height: 17px;
  }
  .award-bonus {
    font-size: 13px;
    font-weight: 500;
    color: #FB4942;
    line-height: 17px;
  }
  .award-list-container {
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 494px;
    left: 0;
    padding: 0 6px;
    .award-list-box {
      box-sizing: border-box;
      border-radius: 12px;
      padding: 20px 17px 19px 20px;
      background-color: #fff;
      position: relative;
    }

    .customArraw {
      position: absolute;
      border-bottom: 12px solid #fff;
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
      border-top: 12px solid transparent;
      top: -24px;
      left: 80px;
    }
    .customArraw2 {
      left: 240px;
    }
  }
  .invite-btn-wrap {
    padding: 0 25px;
    margin-top: 112px;
  }
  .invite-desc {
    font-size: 12px;
    font-weight: 400;
    color: #7B7B7B;
    margin-top: 10px;
    line-height: 1;
    text-align: center;
    padding-bottom: 19px;
  }
  .invite-must {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 37px;
    background: linear-gradient(-90deg, #C23A2E 0%, #E24A3C 99%);
    border-radius: 19px;
    font-size: 22px;
    font-weight: bold;
    color: #FFF440;
  }
  .invite-wrap {
    padding: 0 15px;
    margin-top: 16px;
    .invite-card {
      padding: 19px 15px 14px;
      background: linear-gradient(0deg, #FFE7E1 0%, #FFFFFF 100%);
      border-radius: 0px 10px 10px 10px;
    }
    .invite-card-bg {
      background-image: url(${InviteCard});
      height: 39px;
      width: 179px;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .invite-text {
        font-size: 17px;
        font-weight: 500;
        color: #323232;
        line-height: 17px;
        margin-right: 8px;
      }
      .invite-icon {
        width: 16px;
        height: 16px;
      }
    }
    .withdraw-wrap {
      padding: 0 25px;
      margin-top: 18px;
      .withdraw-btn {
        height: 53px;
        background: linear-gradient(-90deg, #C23A2E 0%, #E14A3C 99%);
        border-radius: 26px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .withdraw-text {
        font-size: 18px;
        font-weight: bold;
        color: #FFF440;
        line-height: 18px;
        margin-bottom: 6px;
      }
      .withdraw-desc {
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 12px;
      }
    }
  }
  .invite-data-wrap {
    display: flex;
    height: 73px;
    border-top: 1px solid #FFE7E1;
    border-left: 1px solid #FFE7E1;
    border-radius: 8px;
    background: #FFFFFF;
    padding-top: 15px;
    box-sizing: border-box;
    .invite-split {
      width: 1px;
      height: 44px;
      background: #FFC3BE;
    }
    .invite-nums {
      text-align: center;
      flex: 1;
    }
    .invite-item {
      font-size: 15px;
      font-weight: 500;
      color: #323232;
      line-height: 15px;
      margin-bottom: 17px;
    }
    .invite-value {
      font-size: 15px;
      font-weight: bold;
      color: #FE5E37;
      line-height: 15px;
    }
  }
  .rank-container {
    padding: 0 14px;
    margin-top: 18px;
    .rank-content {
      background: linear-gradient(0deg, #FFE7E1 0%, #FFFFFF 100%);
      border-radius: 0px 0px 10px 10px;
    }
    .rank-box {
      position: relative;
      .champion-user {
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
        display: flex;
        justify-content: space-between;
        padding: 0 40px;
        box-sizing: border-box;
        .user-bg {
          border-radius: 30px;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(0deg, #FB4541 0%, #FF954E 100%);
          .champion-avatar {
            width: 56px;
            height: 56px;
            border-radius: 28px;
          }
        }
        .champion-name {
          font-size: 13px;
          font-weight: bold;
          color: #010101;
          line-height: 13px;
          margin-top: 6px;
          max-width: 60px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .champion-award {
          margin-top: 2px;
          width: 66px;
          height: 18px;
          background: linear-gradient(270deg, #FB4541 0%, #FF954E 99%);
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          font-weight: 500;
          color: #FFFFFF;
        }
        .champion-item {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .champion1 {
          padding-top: 63px;
        }
        .champion2 {
          padding-top: 23px;
        }
        .champion3 {
          padding-top: 77px;
        }
        .champion-empty {
          font-size: 13px;
          font-weight: bold;
          color: #010101;
          line-height: 13px;
          padding-top: 66px;
          width: 66px;
          text-align: center;
        }
      }
      .champion-wrap {
        padding: 122px 27px 0;
        .champion-img {
          width: 100%;
        }
      }
    }
    .rank-empty {
      height: 295px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 59px;
      box-sizing: border-box;
      .rank-empty-title {
        font-size: 24px;
        font-weight: bold;
        color: #292929;
        line-height: 24px;
        margin-bottom: 11px;
      }
      .rank-empty-desc {
        font-size: 13px;
        font-weight: 400;
        color: #727272;
        line-height: 19px;
      }
      .rank-empty-img {
        width: 75px;
        height: 84px;
        margin-bottom: 38px;
      }
    }
    .champion-desc {
      font-size: 11px;
      font-weight: 400;
      color: #696969;
      text-align: center;
      line-height: 12px;
      margin-top: 12px;
    }
  }
  .rule-wrap {
    background: linear-gradient(0deg, #FFE7E1 0%, #FFFFFF 100%);
    border-radius: 0px 10px 10px 10px;
    padding: 17px 17px 39px 22px;
    color: #323232;
    font-size: 16px;
    line-height: 20px;
  }
  .rule-container {
    margin-top: 18px;
    .rule-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 6px;
      margin-top: 16px;
      &:first-child {
        margin-top: 0;
      }
    }
    .heavy-title {
      font-weight: bold;
      margin-bottom: 4px;
      &:last-child { 
        margin-bottom: 0px;
      }
    }
  }
  .rank-split {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .split-dot {
      height: 20px;
      width: 20px;
      background: #C23A2E;
      border-radius: 10px;
    }
    .split-dot1 {
      margin-left: -10px;
    }
    .split-dot2 {
      margin-right: -10px;
    }
    .split-star {
      width: 11px;
      height: 10px;
      background-image: url(${StarImg});
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: 0 5px;
    }
    .split-line {
      flex: 1;
      height: 2px;
      background-image: url(${SplitLine});
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .split-text {
      color: #C23A2E;
      font-size: 14px;
      padding: 0 4px;
      font-weight: bold;
    }
  }
  .rank-value-wrap {
    flex: 1;
  }
  .rank-self {
    margin-top: 23px;
    height: 82px;
    background: linear-gradient(-89deg, #FF5551 0%, #FF954E 99%);
    border-radius: 0px 0px 10px 10px;
    padding: 0 22px 0 15px;
    display: flex;
    align-items: center;
    color: #fff;
    .self-wrap {
      display: flex;
      align-items: center;
      .self-avatar {
        height: 65px;
        width: 65px;
        border-radius: 32.5px;
        border: 2px solid #FFC852;
        box-sizing: border-box;
        .my-avatar {
          height: 61px;
          width: 61px;
          border-radius: 30.5px;
        }
      }
      .self-text {
        margin-left: 17px;
      }
    }
    .self-values {
      flex: 1;
      margin-left: 11px;
      display: flex;
      justify-content: space-between;
    }
    .rank-distance {
      margin-top: 8px;
      font-size: 10px;
      font-weight: 400;
      color: #FFFEFE;
      padding-left: 11px;
    }
  }
  .active-desc {
    text-align: center;
    padding: 24px 0 81px;
    font-size: 12px;
    font-weight: 400;
    color: #FF9696;
    line-height: 20px;
  }
  .my-invite-btn {
    width: 60px;
    height: 60px;
    background: linear-gradient(-37deg, #FF7200 0%, #FFAE00 99%);
    border-radius: 50%;
    font-size: 15px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: fixed;
    right: 14px;
    bottom: 86px;
    z-index: 10;
  }

  .bottom-fixed {
    height: 60px;
    background: #FFFFFF;
    border-radius: 10px 10px 0px 0px;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 10;
  }
  .bottom-share {
    font-size: 14px;
    font-weight: 400;
    color: #575757;
    line-height: 20px;
    text-align: center;
    margin-top: 11px;
  }
  .share-arraw-wrap {
    display: flex;
    justify-content: center;
    padding-top: 9px;
  }
  .share-arraw {
    width: 18px;
    height: 10px;
  }
  .share-img {
    width: 20px;
    width: 20px;
    vertical-align: middle;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_42/index.js